"use client"

import { useEffect, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams, useNavigate } from "react-router-dom"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"
import actionTypes from "../../../constants/actionTypes"

function ClubDetail() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()

    const board = useSelector((state) => state.board)
    const loginData = useSelector((state) => state.login)

    const fetchClubDetail = useCallback(() => {
        if (id && !isNaN(id) && id !== "undefined") {
            dispatch({
                type: actionTypes.BOARD_DETAIL_FETCH,
                payload: {
                    id: Number.parseInt(id),
                    boardId: 17,
                },
            })
        } else {
            dispatch({
                type: actionTypes.BOARD_DETAIL_FETCH_FAILED,
                payload: "유효하지 않은 동아리 ID입니다.",
            })
        }
    }, [dispatch, id])

    const hasAdminPermission = useCallback(() => {
        if (!loginData) return false
        const { isLogin, role } = loginData
        const adminRoles = ["ROLE_WEB_ADMIN", "ROLE_ADMIN"]
        return isLogin && role && adminRoles.includes(role)
    }, [loginData])

    useEffect(() => {
        fetchClubDetail()
    }, [fetchClubDetail])

    const handleEdit = () => {
        if (board.detail.data?.id) {
            navigate(`/clubs/edit/${board.detail.data.id}`)
        }
    }

    const handleDelete = () => {
        if (!board.detail.data?.id) {
            alert("동아리 정보를 찾을 수 없습니다.")
            return
        }

        if (window.confirm("정말로 삭제하시겠습니까?")) {
            dispatch({
                type: actionTypes.BOARD_DELETE,
                payload: {
                    boardId: board.detail.data.id,
                },
            })

            setTimeout(() => {
                navigate("/clubs")
            }, 500)
        }
    }

    const handleBack = () => {
        navigate("/clubs")
    }

    const formatDate = (dateString) => {
        if (!dateString) return ""
        const date = new Date(dateString)
        return date.toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
    }

    const renderContent = (isMobile = false) => {
        const { loading, error, data } = board.detail

        if (loading) {
            return (
                <div className={`club-detail-loading ${isMobile ? "mobile" : ""}`}>
                    <div className="loading-spinner"></div>
                    <p>동아리 정보를 불러오는 중...</p>
                </div>
            )
        }

        if (error || !data) {
            return (
                <div className={`club-detail-error ${isMobile ? "mobile" : ""}`}>
                    <div className="error-icon">⚠️</div>
                    <p>{error || "동아리를 찾을 수 없습니다."}</p>
                    <button className="btn btn-primary" onClick={handleBack}>
                        목록으로 돌아가기
                    </button>
                </div>
            )
        }

        const clubItem = data

        return (
            <div className={`club-detail-container ${isMobile ? "mobile" : ""}`}>
                <div className="club-detail-wrapper">
                    {!isMobile && (
                        <div className="club-detail-header">
                            <div className="club-detail-meta">
                                <span className="author">
                                    <i className="fas fa-user"></i> {clubItem.memberName}
                                </span>
                                <span className="date">
                                    <i className="fas fa-calendar"></i> {formatDate(clubItem.createdAt)}
                                </span>
                                <span className="views">
                                    <i className="fas fa-eye"></i> {clubItem.viewCount}
                                </span>
                            </div>
                        </div>
                    )}

                    <div className="club-detail-content">
                        {isMobile && <h1 className="club-detail-title">{clubItem.title}</h1>}
                        <div
                            className={`content-body ${isMobile ? "mobile-content" : ""}`}
                            dangerouslySetInnerHTML={{ __html: clubItem.contents }}
                        />
                    </div>

                    <div className={`club-detail-actions ${isMobile ? "mobile-actions" : ""}`}>
                        <button className={`btn btn-list ${isMobile ? "mobile-btn" : ""}`} onClick={handleBack}>
                            목록
                        </button>
                        {hasAdminPermission() && (
                            <div className={`action-group ${isMobile ? "mobile-action-group" : ""}`}>
                                <button className={`btn btn-edit ${isMobile ? "mobile-btn" : ""}`} onClick={handleEdit}>
                                    수정
                                </button>
                                <button className={`btn btn-delete ${isMobile ? "mobile-btn" : ""}`} onClick={handleDelete}>
                                    삭제
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <section className="pf-page">
            <PC>
                <div className="background">
                    <div className="layout">{renderContent(false)}</div>
                </div>
            </PC>
            <Notebook>
                <div className="background">
                    <div className="layout">{renderContent(false)}</div>
                </div>
            </Notebook>
            <Tablet>
                <div className="background">
                    <div className="layout">{renderContent(false)}</div>
                </div>
            </Tablet>
            <Mobile>
                <div className="background">
                    <div className="layout">{renderContent(true)}</div>
                </div>
            </Mobile>
        </section>
    )
}

export default ClubDetail